import { Box, Typography } from "@mui/material";
import pic from "assets/splashpage/va_bundled.webp";
import { OrganizationUserContext } from "contexts/Organization";
import { SplashPage } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import { getSource } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import SplashPageHome from "../../components/Home";

const VaBundledProgramInfo = () => {
  const source = getSource();
  const { handleCheckout } = useSubscription();
  const { currentOrg } = useContext(OrganizationUserContext);

  const checkOutForSplashPage = (plan: Plans) => {
    handleCheckout(
      undefined,
      source || "",
      window.location.pathname,
      SplashPage.va_bundled,
    );
  };

  return (
    <SplashPageHome
      checkOutForSplashPage={checkOutForSplashPage}
      sidebarPic={pic}
      planDetails={
        <>
          <Typography variant="h2">Bento VA Add-Ons</Typography>
          <Typography variant="h6">
            Personalize your pitch strategy. Maximize your results.
          </Typography>

          <Typography>
            Your Virtual Assistant already does the heavy lifting — now take it
            further with flexible add-ons built to help you land deals faster.
          </Typography>

          <Box sx={{ mt: 6 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>Choose Your Add-Ons</strong>
            </Typography>
            🟢 <strong> Increase your automated email volume </strong> Expand
            your reach by pitching in to additional brands every month. Each
            package gives you 150 extra automated emails.
            <br />
            🟢 <strong>Custom Pitch Template</strong> Get a professional,
            done-for-you pitch template written for you. Use it to stand out in
            your outreach and increase your reply rate.
            <br />
            🟢 <strong>1:1 Support Call</strong> Hop on a private strategy call
            with our team. Get expert advice, troubleshoot challenges, and
            fine-tune your outreach plan.
            <br />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>Why Add-Ons Work</strong>
            </Typography>
            <li>
              <strong>Wider Reach</strong>: Target brands more broadly by
              expanding niches.
            </li>
            <li>
              <strong>Stronger Messaging</strong>: Stand out with polished,
              high-converting pitches.
            </li>
            <li>
              <strong>Extra Support</strong>: Get personalized help exactly when
              you need it.
            </li>
          </Box>
        </>
      }
      fromRoutes={`${routes.vaBundled}`}
      plan={Plans.VA_YEARLY}
      notQualified={!currentOrg?.isVaUser}
      buttonText={
        <>
          {!currentOrg?.isVaUser && currentOrg?.id && (
            <Typography sx={{ color: "warning.main" }}>
              <em>
                You have not subscribed to our Virtual Assistant plan yet.
                Please subscribe to the{" "}
                <a
                  href="https://app.onbento.com/va"
                  target="_blank"
                  rel="noreferrer"
                >
                  Virtual Assistant plan
                </a>{" "}
                before purchasing add-ons.
              </em>
            </Typography>
          )}
          {!currentOrg?.id && (
            <Typography>Please log in first to purchase the add-on.</Typography>
          )}
        </>
      }
    />
  );
};

export default VaBundledProgramInfo;
